import { MetricsData } from '../../components/metrics/metrics.component';

export const stepData = [
  {
    imgSrc: 'images/SC_step1.png',
    altText: $localize`Step 1`,
    heading: $localize`1. John wants to reduce soil compaction`,
    paragraph: $localize`The field has a wet area, and the farmer considers the best way to drive this field to reduce soil compaction.`,
  },
  {
    imgSrc: 'images/SC_step2.png',
    altText: $localize`Step 2`,
    heading: $localize`2. John plans the field operation`,
    paragraph: $localize`He selects fields and the operation type. He selects machine and implement, and adjusts their settings as needed, e.g. tire configuration.`,
  },
  {
    imgSrc: 'images/SC_step3.png',
    altText: $localize`Step 3`,
    heading: $localize`3. John selects a route`,
    paragraph: $localize`The tool suggests routes optimised by time, fuel consumption and soil compaction. John investigates the suggested routes, and selects the one he wants to use.`,
  },
  {
    imgSrc: 'images/SC_step4.png',
    altText: $localize`Step 4`,
    heading: $localize`4. John is ready to go to the field`,
    paragraph: $localize`In the field he uses the planned route when doing the operation. The route takes the wet area into account, and this way soil compaction is reduced.`,
  },
];

export const metricsData: { time: MetricsData[]; compaction: MetricsData[] } = {
  time: [
    {
      label: $localize`Time`,
      value: $localize`1 hr 5 min`,
    },
    {
      label: $localize`Fuel consumption`,
      value: $localize`11,4 L`,
    },
    {
      label: $localize`Soil compaction`,
      value: $localize`10%`,
      indicator: 'error',
    },
    {
      label: $localize`Risk of soil compaction`,
      value: $localize`5%`,
      indicator: 'warning',
    },
  ],
  compaction: [
    {
      label: $localize`Time`,
      value: $localize`1 hr 10 min`,
    },
    {
      label: $localize`Fuel consumption`,
      value: $localize`12,3 L`,
    },
    {
      label: $localize`Soil compaction`,
      value: $localize`4%`,
      indicator: 'error',
    },
    {
      label: $localize`Risk of soil compaction`,
      value: $localize`6%`,
      indicator: 'warning',
    },
  ],
};
